
import CategorySection from "./CategorySection";


function toTitleCase(str) {
  if (!str) return "";
  return str
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, (s) => s.toUpperCase())
    .trim();
}

export default function PackingList({ items, meta, checkedItems, setCheckedItems }) {
  // Count total items (including nested kids + custom)
  let totalCount = 0;
  Object.keys(items).forEach((category) => {
    if (category === "custom") return;
    if (category === "kids") {
      Object.values(items.kids).forEach((arr) => {
        totalCount += arr.length;
      });
    } else {
      totalCount += items[category].length;
    }
  });
  if (items.custom) totalCount += items.custom.length;

  const checkedCount = Object.keys(checkedItems).length;
  const progress = totalCount > 0 ? (checkedCount / totalCount) * 100 : 0;

  // ✅ Update state when a checkbox toggles
  const handleToggle = (id, checked) => {
    setCheckedItems((prev) => {
      const updated = { ...prev };
      if (checked) {
        updated[id] = true;
      } else {
        delete updated[id];
      }
      return updated;
    });
  };

  return (
    <div>
      <h2 className="app-heading">
        Packing List for{" "}
        {meta.profileName ? `${meta.profileName} – ` : ""}
        {meta.destination} ({meta.days} days)
      </h2>

      {/* Weather Dashboard */}
      {meta.weather && meta.weather.length > 0 && (
        <div className="weather-card">
          <h3 style={{ marginBottom: "10px" }}>
            {meta.weather.length}-Day Forecast
          </h3>
          <div className="forecast-row">
            {meta.weather.map((day, idx) => (
              <div
                key={idx}
                className={`weather-day ${
                  day.condition.toLowerCase().includes("rain")
                    ? "rainy"
                    : day.condition.toLowerCase().includes("cloud")
                    ? "cloudy"
                    : day.condition.toLowerCase().includes("snow")
                    ? "snowy"
                    : day.avgTemp > 80
                    ? "hot"
                    : day.avgTemp < 40
                    ? "cold"
                    : "mild"
                }`}
              >
                <p className="weekday">
                  {new Date(day.date).toLocaleDateString(undefined, {
                    weekday: "short",
                  })}
                </p>
                <img src={day.icon} alt={day.condition} />
                <p className="temp">{day.avgTemp}°F</p>
                <small>{day.condition}</small>
              </div>
            ))}
          </div>
        </div>
      )}

      

      {/* Progress Tracker */}
      <div style={{ margin: "15px 0" }}>
        <div style={{ fontSize: "14px", marginBottom: "6px", textAlign: "center" }}>
          {checkedCount} / {totalCount}
        </div>
        <div
          style={{
            height: "10px",
            borderRadius: "6px",
            background: "#eee",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: `${progress}%`,
              height: "100%",
              background: "#6B91B5",
              transition: "width 0.3s ease",
            }}
          />
        </div>
      </div>

      {/* Render categories */}
      {Object.keys(items).map((category) => {
        if (category === "custom") return null;

        if (category === "kids") {
          return (
            <details key="kids" open style={{ marginBottom: "10px" }}>
              <summary style={{ fontWeight: "bold", fontSize: "16px" }}>Kids</summary>
              <div style={{ paddingLeft: "20px" }}>
                {Object.keys(items.kids).map((ageGroup) => (
                  <CategorySection
                    key={ageGroup}
                    title={ageGroup}
                    items={items.kids[ageGroup]}
                    checkedItems={checkedItems}
                    onToggle={handleToggle}
                  />
                ))}
              </div>
            </details>
          );
        }

        return (
          <CategorySection
            key={category}
            title={toTitleCase(category)}
            items={items[category]}
            checkedItems={checkedItems}
            onToggle={handleToggle}
          />
        );
      })}

      {items.custom && items.custom.length > 0 && (
        <CategorySection
          title="Custom Items"
          items={items.custom}
          checkedItems={checkedItems}
          onToggle={handleToggle}
        />
      )}
      
    </div>
  );
}
